import * as tslib_1 from "tslib";
import { Model } from '@swim/ui';
var GeometryModel = (function (_super) {
    tslib_1.__extends(GeometryModel, _super);
    function GeometryModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GeometryModel;
}(Model));
export { GeometryModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvbWV0cnktbW9kZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJnZW9tZXRyeS1tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLEtBQUssRUFBQyxNQUFNLFVBQVUsQ0FBQztBQUUvQjtJQUFtQyx5Q0FBSztJQUF4Qzs7SUFFQSxDQUFDO0lBQUQsb0JBQUM7QUFBRCxDQUFDLEFBRkQsQ0FBbUMsS0FBSyxHQUV2QyJ9